import { convertMetricToFeet } from '../../util';
import { DivAttrDetail } from './style';

interface AreaDetailProps {
  area: number | null;
}

export default function FacetArea({ area }: AreaDetailProps) {
	return (
		<DivAttrDetail className="area-sqft-wrap">
			<label>
        Area <small>(sqft)</small>:
			</label>
			<span>{area != null ? convertMetricToFeet(area, 'm2') : 'N/A'}</span>
		</DivAttrDetail>
	);
}
